import type { Messages } from '../catalogue.en'

export const localizedField: Partial<Messages> = {
  'localizedField.badge': 'Языки этого значения',
  'localizedField.original': 'Оригинал',
  'localizedField.makeOriginal': 'Сделать оригиналом',
  'localizedField.makeOriginalFor': 'Сделать оригиналом: {language}',
  'localizedField.remove': 'Убрать язык: {language}',
  'localizedField.addLanguage': 'Добавить язык',
  'localizedField.addLanguagePlaceholder': 'Выберите язык',
  'localizedField.suggest': 'Предложить',
  'localizedField.suggestFor': 'Предложить перевод: {language}',
  'localizedField.suggestAll': 'Предложить для всех недостающих',
  'localizedField.suggesting': 'Готовим предложение…',
  'localizedField.suggestFailed': 'Не удалось подготовить предложение. Попробуйте ещё раз.',
  'localizedField.sourceRequired': 'Текст оригинала обязателен.',
  'localizedField.blank': 'Введите перевод или уберите язык.',
  'localizedField.tooLong': 'Текст слишком длинный.',
  'localizedField.invalidText': 'Текст содержит символы, которые нельзя сохранить.',
  'localizedField.tooManyLanguages': 'В это значение больше нельзя добавить языки.',
  'localizedField.shownIn': 'Показано на языке: {language}',
}
